class AuthRoutes {
  public static readonly LOGIN = '/login';
  public static readonly REGISTER = '/verify-otp';
  public static readonly PROFILE = '/profile';
  public static readonly INVESTOR_ACCOUNTS = '/accounts/investor';
  public static readonly IBDAX_ACCOUNTS = '/accounts/ibdax';

  //
  public static readonly INVITE_INVESTOR = '/users/invite-investor';
}

export default AuthRoutes;
